import React from "react";
import Layout from "../Layout";
import { dataGroups } from "../../../data/supervisor/scripts/scripts";
import CrossProductsPage from "../../../widgets/supervisor/scripts/CrossProduct/CrossProduct";
// import CrossProductsPage from "../../../widgets/client/scripts/CrossProduct/CrossProduct";

function ScriptsSupervisor(props) {
  return (
    // <Layout>
    //   <ScriptsTable dataGroups={dataGroups} />
    // </Layout>

    <Layout>
      <CrossProductsPage></CrossProductsPage>
    </Layout>
  );
}

export default ScriptsSupervisor;
